"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _customerInfo = _interopRequireDefault(require("@/components/customerInfo"));
var _storePoint = require("@/api/storePoint");
var _public = require("@/libs/public");
var _validate = require("@/utils/validate");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'addClerk',
  components: {
    customerInfo: _customerInfo.default
  },
  props: {
    storeSelectList: Array
  },
  data: function data() {
    var _this = this;
    var validateUpload = function validateUpload(rule, value, callback) {
      if (!_this.ruleForm.avatar) {
        callback(new Error('请上传商城用户图片'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      dialogFormVisible: false,
      id: 0,
      ruleForm: {
        phone: '',
        storeId: '',
        uid: '',
        avatar: ''
      },
      name: '',
      rules: {
        uid: [{
          required: true,
          message: '请选择管理员',
          trigger: 'change'
        }],
        storeId: [{
          required: true,
          message: '请选择门店地址',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    //接收来自子集的值；
    upImgUid: function upImgUid(row) {
      this.ruleForm.avatar = row.account;
      this.ruleForm.uid = row.id;
    },
    upImg: function upImg() {
      this.$refs.customer.dialogFormVisible = true;
      this.$refs.customer.tableList();
    },
    //详情
    getInfo: function getInfo(id) {
      var _this2 = this;
      this.id = id;
      this.loading = true;
      (0, _storePoint.storeStaffInfoApi)({
        id: id
      }).then(function (res) {
        _this2.ruleForm = res;
        _this2.loading = false;
      }).catch(function (res) {
        _this2.loading = false;
      });
    },
    //取消
    cancel: function cancel() {
      this.dialogFormVisible = false;
      this.clearFrom();
      this.resetForm('ruleForm');
      this.ruleForm.avatar = '';
      this.id = 0;
    },
    //数据归为初始状态
    clearFrom: function clearFrom() {
      this.ruleForm.phone = '';
      this.ruleForm.staffName = '';
    },
    //重置
    resetForm: function resetForm(name) {
      this.$refs[name].resetFields();
    },
    // 提交
    submitForm: (0, _validate.Debounce)(function (name) {
      var _this3 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          var phone = _this3.ruleForm.phone;
          if (phone) {
            if (!/^1[3456789]\d{9}$/.test(phone)) {
              return _this3.$message.error('手机号格式不正确');
            }
          }
          (0, _storePoint.storeStaffSaveApi)(_this3.ruleForm).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _this3.$message.success('提交成功');
                  _this3.dialogFormVisible = false;
                  _this3.$emit('tableList');
                  _this3.clearFrom();
                  _this3.resetForm(name);
                  _this3.id = 0;
                  (0, _public.getStoreStaff)();
                case 1:
                  return _context.a(2);
              }
            }, _callee);
          })));
        } else {
          return false;
        }
      });
    }),
    //  编辑
    editForm: (0, _validate.Debounce)(function (name) {
      var _this4 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          var phone = _this4.ruleForm.phone;
          if (phone) {
            if (!/^1[3456789]\d{9}$/.test(phone)) {
              return _this4.$message.error('手机号格式不正确');
            }
          }
          (0, _storePoint.storeStaffUpdateApi)(_this4.ruleForm).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _this4.$message.success('编辑成功');
                  _this4.dialogFormVisible = false;
                  _this4.$emit('tableList');
                  _this4.clearFrom();
                  _this4.resetForm(name);
                  _this4.id = 0;
                  (0, _public.getStoreStaff)();
                case 1:
                  return _context2.a(2);
              }
            }, _callee2);
          })));
        } else {
          return false;
        }
      });
    })
  }
};